import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66fafdec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "board_table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "15%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "4" }, "구분")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "6" }, "업소 유형분류"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "3" }, [
      /*#__PURE__*/_createTextVNode(" 계 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" (A + B) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "합")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "출장형"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "조건만남형"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "업소형"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "기타"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "해당없음"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "미삭제(A)"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "삭제요청(B)")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "주점형"),
    /*#__PURE__*/_createElementVNode("th", null, "위장형")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "총 계 (건)", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { colspan: 10 }
const _hoisted_16 = { class: "board_graph_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          (!$setup.props.loading)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.list, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    (item.sns === 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                          _createTextVNode(" X "),
                          _hoisted_7,
                          _createTextVNode(" (구 트위터) ")
                        ]))
                      : (item.sns === 2)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, "구글"))
                        : (item.sns === 3)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_9, "네이버"))
                          : (item.sns === 4)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_10, "유튜브"))
                            : (item.sns === 5)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_11, "인스타"))
                              : (item.sns === 6)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_12, "블루스카이"))
                                : _createCommentVNode("", true),
                    _createElementVNode("td", null, _toDisplayString(item.cntType1 ? $setup.numberFormat(item.cntType1) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType4 ? $setup.numberFormat(item.cntType4) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType2 ? $setup.numberFormat(item.cntType2) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType3 ? $setup.numberFormat(item.cntType3) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType6 ? $setup.numberFormat(item.cntType6) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType9 ? $setup.numberFormat(item.cntType9) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntType5 ? $setup.numberFormat(item.cntType5) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntMonitoring ? $setup.numberFormat(item.cntMonitoring) : 0), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cntDel ? $setup.numberFormat(item.cntDel) : 0), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType1)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType4)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType2)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType3)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType6)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType9)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntType5)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntMonitoring)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntDel)), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_15, [
                    _createVNode(_component_Spinner)
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.chartData, (data) => {
        return (_openBlock(), _createBlock(_component_Chart, {
          style: {"min-height":"400px"},
          defaultLayout: $setup.chartLayout,
          data: data
        }, null, 8, ["defaultLayout", "data"]))
      }), 256))
    ])
  ], 64))
}